import React, { useState, useEffect } from 'react'
import TabsContent from '../../common/components/TabsContent'
import TabContent from '../../common/components/TabsContent/TabContent'
import BannerBg from '../../common/components/BannerBg'
import Layout from '../Layout'
import './index.css'
import {Button, FormControl, Message} from 'tinper-bee';
import * as util from '../../utils';
class Collections extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
        };
    }
    async addNPM(){
        const data = {
            npmName: this.state.npmName
        }
        const result: any = await util.post('/package/registry', data);
        if(result.status === 200) {
            Message.create({content: '组件注册成功', color: "success"});
            this.props.history.push('/package/detail/' + this.state.npmName)
        } else {
            Message.create({content: result.message, color: "danger"});
        }
    }
    async refresh(){
        const data = {
            ynpmName: this.state.ynpmName
        }
        const result: any = await util.post('/package/refresh', data);
        if(result.status === 200) {
            Message.create({content: '刷新成功', color: "success"});
            this.props.history.push('/package/detail/' + this.state.ynpmName)
        } else {
            Message.create({content: result.message, color: "danger"});
        }
    }
    async componentDidMount() {}
    render() {
        return (
            <div className='block-sub-banner'>
                <div className='collections-lists'>
                    <div className='wrap'>
                        <div className='page-collections-wrap'>
                            <div className='searchTitle'>YNPM镜像刷新</div>
                            <div className='refresh-input'>
                                <p>
                                    使用ynpm-tool发布到YNPM镜像上的组件，会被自动注册；
                                </p>

                                <p>
                                    使用npm + registry发布到YNPM镜像上的组件，会在4个小时内被同步注册；
                                </p>

                                <p>
                                    如果想手动刷新，请输入组件名称：
                                </p>
                                <FormControl onChange={(e)=> this.setState({ynpmName: e})} value={this.state.ynpmName} />
                            </div>
                            <div>
                                <Button colors={'primary'} onClick={() => this.refresh()}>手动刷新</Button>
                            </div>
                        </div>
                        <div className='page-collections-wrap'>
                            <div className='searchTitle'>NPM镜像手动注册</div>
                            <div className='refresh-input'>
                                <p>
                                    我们不建议您将组件发布到NPM镜像上，这容易造成大陆地区下载时发生网络错误;
                                </p>
                                <p>
                                    如果您执意发布到NPM镜像，注册后我们会去NPM镜像同步部分信息，但这可能存在同步时间差造成的数据异常;
                                </p>
                                <p>
                                    请输入您的组件名称：
                                </p>
                                <FormControl onChange={(e)=> this.setState({npmName: e})} value={this.state.npmName} />
                            </div>
                            <div>
                                <Button colors={'primary'} onClick={() => this.addNPM()}>注册</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default Layout(Collections, 'collections-page')
